import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { useWizard } from "../../../../../shared/components/common/ui/Wizard/useWizard";
import { WizardStepper } from "../../../../../shared/components/common/ui/Wizard/WizardStepper";
import { WizardFooter } from "../../../../../shared/components/common/ui/Wizard/WizardFooter";

import use123zapStore from "../../../../../context/123zapStore";

import ApiRestStepForm from "./steps/apiRestStepForm";
import ApiRestStepMapping from "./steps/apiRestStepMapping";

import useApiRestAddController from "../../../hooks/useApiRestAddController";

const STEPS = [
  { id: "form", label: "Informações da API", component: ApiRestStepForm },
  {
    id: "mapping",
    label: "Mapeamento de dados",
    component: ApiRestStepMapping,
  },
];

export default function PageAddApiRest() {
  const navigate = useNavigate();

  const setAlreadyFetchSheets = use123zapStore(
    (state) => state.setAlreadyFetchSheets,
  );

  const ctrl = useApiRestAddController({
    setAlreadyFetchSheets,
  });

  const wizard = useWizard({
    steps: STEPS,
    initialStepId: "form",
  });

  const CurrentStepComponent = wizard.currentStep.component;

  const [formData, setFormData] = useState({
    title: "",
    desc: "",
    method: "",
    url: "",
    authorization: "",
    body: "",
  });

  const [page, setPage] = useState(0);

  const [isValid, setIsValid] = useState(false);
  const [attemptedNext, setAttemptedNext] = useState(false);
  const [isChecking, setIsChecking] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setAttemptedNext(false);
  }, [wizard.currentStep.id]);

  useEffect(() => {
    if (wizard.currentStep.id === "mapping") {
      setPage(0);
    }
  }, [wizard.currentStep.id]);

  const handleNext = async () => {
    if (isChecking || isSaving) return;

    /* STEP 1 — VERIFY API */
    if (wizard.currentStep.id === "form") {
      if (!isValid) {
        setAttemptedNext(true);
        return;
      }

      setIsChecking(true);
      const success = await ctrl.handleVerifyAPI(formData);
      setIsChecking(false);

      if (!success) return;

      wizard.next();
      return;
    }

    /* STEP 2 — MAPPING */
    if (wizard.currentStep.id === "mapping") {
      const result = ctrl.validateBeforeFinish();
      if (!result.valid) return;

      let message = "Tem certeza que deseja salvar a API?";

      if (result.emptyCount > 0) {
        message =
          `Existem ${result.emptyCount} campos sem seleção.\n\n` +
          "Eles não serão utilizados.\n\n" +
          "Deseja continuar mesmo assim?";
      }

      if (!window.confirm(message)) return;

      setIsSaving(true);

      await ctrl.handleSubmit({
        formData,
        onSuccess: () => navigate("/listagens"),
      });

      setIsSaving(false);
    }
  };

  const handleBack = () => {
    if (isChecking || isSaving) return;
    wizard.back();
  };

  return (
    <Box sx={{ width: "100%", px: 4, py: 3 }}>
      <WizardStepper
        steps={wizard.steps}
        activeStep={wizard.currentStepIndex}
      />

      <Box sx={{ maxWidth: 860 }}>
        <CurrentStepComponent
          data={wizard.currentStep.id === "form" ? formData : ctrl.dataR}
          updateData={(values) =>
            setFormData((prev) => ({ ...prev, ...values }))
          }
          setIsValid={setIsValid}
          showErrors={attemptedNext}
          setData={ctrl.setDataR}
          variablesByCategory={ctrl.variablesOfTemplate}
          page={page}
          setPage={setPage}
        />
      </Box>

      <WizardFooter
        canGoBack={wizard.canGoBack}
        onBack={handleBack}
        onNext={handleNext}
        nextLabel={
          isChecking
            ? "Consultando API..."
            : wizard.currentStep.id === "mapping"
              ? "Finalizar"
              : "Avançar"
        }
        isSaving={isSaving}
        isNextDisabled={isChecking || isSaving}
      />
    </Box>
  );
}
